export enum MdsOutcomeEnum {
  CONVERTED = 'Converted',
  ACTIVE = 'Active',
  UNQUALIFIED = 'Unqualified',
  ENGAGED = 'Engaged',
  NOT_ELIGIBLE = 'Not Eligible',
  COMPLETE = 'Complete',
}
